import type {FC} from 'react'

export const OpenQuote: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="11" viewBox="0 0 21 11" fill="none">
    <path
      d="M9.406 0.000122404L6.94034 0.000122296C3.06474 0.000122127 0.5 2.67885 0.5 6.55445L0.5 11H4.83156L4.83156 4.84463H9.406L9.406 0.000122404Z"
      fill="white"
    />
    <path
      d="M20.8483 1.07773e-07L18.3826 0C14.507 -1.69408e-07 11.9423 2.67873 11.9423 6.55433V10.9999H16.2738V4.84451H20.8483V1.07773e-07Z"
      fill="white"
    />
  </svg>
)
